module.exports = __webpack_public_path__ + "static/media/buttercup squash.5ecefb9a.jpg";